<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Application Update</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Application Update</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="ApplicationUpdate">
          <div class="overlay" v-if="is_loading">
            <i class="fas fa-2x fa-sync-alt fa-spin"></i>
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link class="btn btn-info" :to="{ name: 'ApplicationUpdateList' }"
                  ><i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-8">
                  <div v-if="organizationId == 1" class="form-group required">
                    <label class="control-label">Audra</label>
                    <input
                      v-if="is_edit"
                      type="text"
                      v-model="pre.audraName[value.accountId]"
                      id="account_id_list"
                      class="form-control account_id_list"
                      name="account_id_list"
                      readonly
                    />
                    <multiselect
                      v-else
                      v-model="value.account_id_list"
                      :options="Object.keys(pre.audraName)"
                      :custom-label="(opt) => pre.audraName[opt]"
                      placeholder="Select Audra"
                      :searchable="true"
                      :multiple="true"
                      id="account_id_list"
                      v-bind:class="{
                        'has-error': errors.has('account_id_list'),
                      }"
                      v-validate="'required'"
                      name="account_id_list"
                    >
                    </multiselect>

                    <div class="help text-danger" v-show="errors.has('accountId')">
                      {{ errors.first("accountId") }}
                    </div>
                  </div>
                  <div class="form-group required">
                    <label class="control-label">Version</label>
                    <input
                      v-if="is_edit"
                      type="text"
                      v-model="pre.versionList[value.version]"
                      id="version"
                      class="form-control version"
                      name="version"
                      readonly
                    />
                    <multiselect
                      v-else
                      v-model="value.version"
                      :options="Object.keys(pre.versionList)"
                      :custom-label="(opt) => pre.versionList[opt]"
                      placeholder="Select Version"
                      :searchable="true"
                      :multiple="false"
                      id="version"
                      v-bind:class="{
                        'has-error': errors.has('version'),
                      }"
                      v-validate="'required'"
                      name="version"
                    >
                    </multiselect>

                    <div class="help text-danger" v-show="errors.has('version')">
                      {{ errors.first("version") }}
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="control-label">Type</label>
                    <div class="d-flex">
                      <label
                        class="radio mr-3"
                        v-for="(update_type, index) in update_types"
                        :key="index"
                      >
                        <input
                          type="radio"
                          :value="update_type.value"
                          v-model="value.fw_type"
                          name="fw_type"
                          id="fw_type"
                          :disabled="is_edit"
                        />
                        <span class="radio-mark"></span>
                        {{ update_type.display }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">
                Submit
              </button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">Update</button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
//import MasterLayout from "@/components/layouts/MasterLayoutComponent";
import { DepartmentsAPI, CommonAPI } from "@/services/api";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import axios from "axios";
import LocalStorage from "@/services/localStorage";

export default {
  name: "ApplicationUpdateForm",
  metaInfo: {
    title: "ApplicationUpdate | Dotlines",
  },
  components: {
    DatePicker,
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    update_types: [
      { display: "Patch Update (Application)", value: "UPDATE_PATCH" },
      { display: "Firmware Update", value: "UPDATE_FIRMWARE" },
    ],

    organizationId: LocalStorage.get("organizationId"),

    value: {
      update_type: "app",
    },
    pre: {
      audraName: {},
      versionList: {},
    },
  }),
  methods: {
    handleSubmission() {
      let _this = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          _this.is_loading = true;
          let api_url = "/applicationupdates";
          let method = "POST";
          if (_this.is_edit) {
            api_url = "/applicationupdates/" + _this.$route.params.id;
            method = "PUT";
          }

          axios({
            method: method,
            url: api_url,
            data: _this.value,
            headers: { "Content-Type": "application/json" },
          })
            .then(function (response) {
              _this.$toaster.success(response.data.message);
              _this.$router.push({ name: "ApplicationUpdateList" });
            })
            .catch((errors) => {
              if (errors.response.status === 500) {
                _this.$toaster.error(errors.response.data.message);
              }
              _this.$setErrorsFromResponse(errors.response.data);
            })
            .finally(() => {
              _this.is_loading = false;
            });
        }
      });
    },
    getDetail: function (id) {
      return new Promise((resolve, reject) => {
        let api_url = "/applicationupdates/" + id;
        axios
          .get(api_url)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            //console.log('error ' + error)
            reject(error);
          });
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        await this.getDetail(this.params.id)
          .then((response) => {
            this.value = response.data;
          })
          .catch((error) => {
            console.log(error.response);
          });
      }

      await CommonAPI.getAuthAudraName()
        .then((response) => {
          this.pre.audraName = response;
        })
        .catch((error) => {
          console.log(error.response);
        });

      await CommonAPI.getversionList()
        .then((response) => {
          this.pre.versionList = response;
        })
        .catch((error) => {
          console.log(error.response);
        });

      this.is_loading = false;
    },
  },
  mounted() {
    this.initialize();
  },
  /* created() {
    this.$emit("update:layout", MasterLayout);
  }, */
};
</script>
